import { createContext, type RefObject, use } from "react";

export const ComboboxContext = createContext<{
  open?: boolean;
  setOpen: (value: boolean) => void;
  multiple?: boolean;
  withoutPopover?: boolean;
  label?: string;
  isMobile?: boolean;
  // The scroll container, registered by Combobox.List so Root's cursor effects can scroll it.
  listRef: RefObject<HTMLDivElement | null>;
  // A mounted Item whose `selected` prop is true announces its cmdk token; Root moves the keyboard
  // cursor there (and scrolls to it) right after the dropdown opens.
  reportSelectedItem: (token: string) => void;
  // Input announces typing; Root resets the cursor/scroll so the list snaps back to the first match.
  notifySearchChanged: () => void;
}>({
  setOpen: () => null,
  multiple: false,
  withoutPopover: false,
  label: undefined,
  isMobile: false,
  listRef: { current: null },
  reportSelectedItem: () => null,
  notifySearchChanged: () => null,
});

export const useComboboxContext = () => use(ComboboxContext);
